import { IAuthDataHandler } from '../../data-handlers/auth/IAuthDataHandler'
import { requestToken } from '../../firebase'
import SessionStorage from '../../services/storage/session-storage/SessionStorage'

export class AuthRepository {
    handler: IAuthDataHandler

    constructor(handler: IAuthDataHandler) {
        this.handler = handler
    }

    setAuth(token: string) {
        this.handler.setAuth(token)
    }

    async requestAuth(
        email: string,
        password: string
    ): Promise<{ token: string }> {
        const data = SessionStorage.get<IWebPushStored>('webPush')

        if (data) {
            this.handler.setXToken(data.token)
        } else {
            try {
                const token = await requestToken()
                if (token) {
                    SessionStorage.set('webPush', { token })
                    this.handler.setXToken(token)
                }
            } catch (err) {
                console.warn('[AuthRepository] push token unavailable, continuing login without it', err)
            }
        }

        return this.handler.requestAuth(email, password)
    }
}

export interface IWebPushStored {
    token: string
}
